import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { usePageMetadata } from "../context/PageMetadataContext";
import { PiscanAPI } from "../api/piscan";
import { useLanguage } from "../context/LanguageContext";

const ReportScamWallet: React.FC = () => {
  const { t, language } = useLanguage();
  const [formData, setFormData] = useState({
    walletAddress: "",
    reason: "",
    email: "",
  });
  const {setHeading, setTitle, setDescription} = usePageMetadata();
  
  useEffect(() => {
    setHeading(t('report_scam.heading'));
    setTitle(t('report_scam.title'));
    setDescription(t('report_scam.description'));
  }, [setTitle, setDescription, setHeading, t, language]);
  
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    try {
      const response = await fetch(PiscanAPI.ReportScam, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
  
      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }
      
      console.log("Scam Wallet Report Submitted Successfully:", formData);
    } catch (error) {
      console.error("Failed to submit the scam wallet report:", error);
    }
  };

  return (
    <div className="white-zone content-page">
      <div className="container py-5">
        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6 col-sm-12">
            <h1 className="mb-4">{t('report_scam.heading')}</h1>
            <p>{t('report_scam.intro_text')}</p>

            {submitted ? (
              <div className="alert alert-success" role="alert">
                {t('report_scam.success_message')}
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="mt-4">
                <div className="mb-3">
                  <label htmlFor="walletAddress" className="form-label">
                    {t('report_scam.form.wallet_address')}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="walletAddress"
                    name="walletAddress"
                    value={formData.walletAddress}
                    onChange={handleChange}
                    required
                    placeholder={t('report_scam.form.wallet_placeholder')}
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="reason" className="form-label">
                    {t('report_scam.form.reason')}
                  </label>
                  <textarea
                    className="form-control"
                    id="reason"
                    name="reason"
                    rows={4}
                    value={formData.reason}
                    onChange={handleChange}
                    required
                    placeholder={t('report_scam.form.reason_placeholder')}
                  ></textarea>
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    {t('report_scam.form.email')}
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder={t('report_scam.form.email_placeholder')}
                  />
                  <small className="text-muted">{t('report_scam.form.email_note')}</small>
                </div>

                <button type="submit" className="btn btn-danger">
                  {t('report_scam.form.submit')}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportScamWallet;
